import { SxProps } from '@mui/material';

import { useDashboardController } from 'api/controllers/DashboardController';

import { useTranslations } from 'context/TranslationContext';

import { RevenueDashboardGrid } from './RevenueDashboardGrid';

interface SettledRevenueProps {
  isOnAllCompanies: boolean;
  sx?: SxProps;
}

export const SettledRevenue = ({
  isOnAllCompanies,
  sx
}: SettledRevenueProps) => {
  const { translate } = useTranslations();
  const { getSettledRevenue } = useDashboardController();

  return (
    <RevenueDashboardGrid
      sx={sx}
      isOnAllCompanies={isOnAllCompanies}
      callToApi={getSettledRevenue}
      gridTitle={translate('labels.settledRevenue')}
      noDataMessage={translate('labels.noSettledRevenueDataAvailable')}
    />
  );
};
